import WorkflowNew from "./workflow-new";

export default WorkflowNew;